import { store } from "@store/index";
import {
  type SideNavigationV2Props,
  type PageV2Component,
  type SideNavigationComponent,
} from "skedyul-ui/src/components/ui/SideNavigationV2";
import { SideNavigationComponentProps } from "@schemas/sideNavigation.schema";
import { close as closeSideNavigation } from "@store/features/layout/sideNavigationSlice";
import { SpanCol } from "skedyul-ui/ui";

/**
 * Tool binding flow schema - now shows a message that tools are configured via YAML.
 * Tools are resolved from the agent's config at runtime, not from database bindings.
 */
export const addToolBindingFlowSchema = (
  args: SideNavigationComponentProps<PageV2Component, { subdomain: string }>,
): SideNavigationV2Props<SideNavigationComponent> => {
  const {
    agents: {
      flow: { scopedAgentId },
      agents: { data: agents },
    },
    sideNavigation: {
      right: { isOpen },
    },
  } = args.state;

  const agent = agents.find((a) => a.id === scopedAgentId);

  return {
    side: "right",
    isOpen,
    width: "500px",
    component: {
      component: "PageV2",
      props: {
        title: "Tool Configuration",
        hideTitle: true,
        header: {
          icon: "Wrench",
          primaryAction: {
            isLoading: false,
            label: "Close",
            handleClick: () => {
              store.dispatch(closeSideNavigation({ position: "right" }));
            },
          },
        },
        content: {
          structure: "sidebar",
          components: [
            {
              type: "Card",
              title: "Tool Configuration",
              props: {
                header: {
                  title: `Tools for ${agent?.name || "Agent"}`,
                  description: "Tools are configured via YAML",
                },
                form: {
                  formVersion: "v1",
                  id: "tool-info-form",
                  fields: [
                    {
                      component: "Textarea" as const,
                      span: 12 as SpanCol,
                      mdSpan: 12 as SpanCol,
                      lgSpan: 12 as SpanCol,
                      props: {
                        id: "tool-info",
                        label: "Configuration",
                        value: `Tools for this agent are defined in the agent's YAML configuration file.

To add or modify tools:
1. Edit the agent's YAML file
2. Add tools to the 'tools' array
3. Deploy the updated configuration

Example:
tools:
  - tool: system:crm:prospect:update:stage
    name: Update Stage
    description: Update prospect stage`,
                        isDisabled: true,
                        rows: 14,
                      },
                    },
                  ],
                },
              },
            },
          ],
        },
      },
    },
  };
};
